import api from './APIService';

class TagService {
	getAll(userId) {
		return api.fetch({ method: 'get', path: '/participant/tag/' + userId });
	}
	create(data) {
		return api.fetch({ method: 'post', path: '/participant/tag/', data });
	}
	update(data) {
		return api.fetch({ method: 'put', path: '/participant/tag/', data });
	}
	delete($userId, $id) {
		return api.fetch({ method: 'delete', path: '/participant/tag/' + $userId + '/' + $id });
	}
	getTagsUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/tag/getTagsUsers', data });
	}
	getEventsWithManualTags(data) {
		return api.fetch({ method: 'post', path: '/participant/tag/events/manual-tags/upcoming', data });
	}
}

export default new TagService();
